import React from 'react'
import { ButtonList, LinkButton, Wrapper } from './StartPage'
import { categories } from '../data/cardInfo'

const QuizSelect = () => {

  return (
    <Wrapper>
      <h2>Välj svårighetsgrad</h2>
      <ButtonList>
        <LinkButton color={categories[2].topColor} to='/quiz/easy'>Lätt</LinkButton>
        <LinkButton color={categories[0].topColor} to='/quiz/hard'>Svårt</LinkButton>
      </ButtonList>
    </Wrapper>
  )
}

export default QuizSelect
